import { get, isNil } from "lodash-es";
import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    cliente: null,

    nombre: "",
    apellido: "",
    nombreWeb: "",
    telCelular: "",
    emailFacturacion: null,
    emailGerencia: "",
    nombreUsuario: "",
    password: "",
    idCobranzaLugarDePago: null,
    idClienteReferenciador: null,

    clienteCargado: false,
    tipoTarjeta: null,
    nroTarjeta: "",

    codigoRapipago: null,
  }),
  mutations: {
    setCliente(state, payload) {
      state.cliente = payload;
    },
    inicializarCliente(state, payload) {
      state.nombre = get(payload, "nombre", "SIN_NOMBRE");
      state.apellido = get(payload, "apellido", "SIN_APELLIDO");
      state.nombreWeb = get(payload, "nombre_web", "SIN_NOMBRE_WEB");
      state.telCelular = get(payload, "cel_personal", "SIN_CELULAR");
      state.emailFacturacion = get(payload, "email_facturacion", null);
      state.emailGerencia = get(
        payload,
        "email_gerencia",
        "SIN_EMAIL_GERENCIA",
      );
      state.nombreUsuario = get(
        payload,
        "nombre_usuario",
        "SIN_NOMBRE_USUARIO",
      );

      state.password = get(payload, "password", "SIN_PASSWORD");

      state.idCobranzaLugarDePago = get(payload, "id_cobranza_lugarPago", null);

      state.idClienteReferenciador = get(
        payload,
        "id_cliente_referenciador",
        null,
      );

      state.clienteCargado = true;
      state.nroTarjeta = get(payload, "tarjetasVisa_nro", null);
      state.tipoTarjeta = get(payload, "tarjetasVisa_tipo", null);
      state.codigoRapipago = get(payload, "rapipagoCodigos_codigo", null);
    },
    setNombre(state, payload) {
      state.nombre = payload;
    },
    setApellido(state, payload) {
      state.apellido = payload;
    },
    setNombreWeb(state, payload) {
      state.nombreWeb = payload;
    },
    setTelCelular(state, payload) {
      state.telCelular = payload;
    },
    setEmailFacturacion(state, payload) {
      state.emailFacturacion = payload;
    },
    setEmailGerencia(state, payload) {
      state.emailGerencia = payload;
    },
    setNombreUsuario(state, payload) {
      state.nombreUsuario = payload;
    },
    setPassword(state, payload) {
      state.password = payload;
    },
    setIdCobranzaLugarDePago(state, payload) {
      state.idCobranzaLugarDePago = payload;
    },
    setIdCliente(state, payload) {
      state.idCliente = payload;
    },
    setIdClienteReferenciador(state, payload) {
      state.idClienteReferenciador = payload;
    },
    setNroTarjeta(state, payload) {
      state.nroTarjeta = payload;
    },
    setTipoTarjeta(state, payload) {
      state.tipoTarjeta = payload;
    },
    setCodigoRapipago(state, payload) {
      state.codigoRapipago = payload;
    },
  },
  actions: {
    setCliente(context, payload) {
      context.commit("setCliente", payload);
    },
    async getCliente({ commit }, payload) {
      const { data } = await axios.get(`/clientes/${payload}`);
      commit("setCliente", data.result);
    },
    async submit(context, payload) {
      try {
        if (
          isNil(context.state.nroTarjeta) &&
          !isNil(context.state.tipoTarjeta)
        ) {
          return {
            ok: false,
            message: "Por favor, ingrese un número de tarjeta",
          };
        }
        const resp = await axios.post("/execute", {
          method: "CLI.ModificarClienteConCobranza",
          parameters: [
            { name: "id_cliente", value: payload.idCliente },
            { name: "nombre", value: context.state.nombre },
            { name: "apellido", value: context.state.apellido },
            { name: "nombre_web", value: context.state.nombreWeb },
            {
              name: "cel_personal",
              value: get(context, "state.telCelular", null),
            },
            {
              name: "email_facturacion",
              value: get(context, "state.emailFacturacion", null),
            },
            { name: "email_gerencia", value: context.state.emailGerencia },
            { name: "nombre_usuario", value: context.state.nombreUsuario },
            { name: "password", value: context.state.password },
            { name: "tipo_tarjeta", value: context.state.tipoTarjeta },
            {
              name: "nro_tarjeta",
              value: !isNil(context.state.tipoTarjeta)
                ? context.state.nroTarjeta.replace(/\s+/g, "")
                : null,
            },
            {
              name: "codigo_rapipago",
              value: get(context, "state.codigoRapipago", null),
            },
            {
              name: "id_cobranza_lugarPago",
              value: get(
                context,
                "state.idCobranzaLugarDePago.id_cobranza_lugarPago",
                null,
              ),
            },
            {
              name: "id_clienteReferenciador",
              value: get(
                context,
                "state.idClienteReferenciador.id_cliente",
                null,
              ),
            },
          ],
        });
        return resp.data;
      } catch (e) {
        return { ok: false, message: e.toString() };
      }
    },
  },
  getters: {
    getCliente(state) {
      return state.cliente;
    },
  },
};
